import * as PIXI from "pixi.js";
import InfoSlider from "./InfoSlider";
import { RootEventBus, EnumRootEventBus } from "../../managers/RootEventBus";
import TextureManager from "../../managers/TextureManager";
import { Dims, Coord } from "../../types/Interface";


const ARROW_PATH = "/info-slider/arrow.png";

export default class InfoSliderArrows extends PIXI.Container {
  private InfoSlider: InfoSlider = InfoSlider.getInstance();
  private RootEventBus = RootEventBus;
  private infoSliderDims: Dims;
  private rightArrow: PIXI.Sprite;
  private leftArrow: PIXI.Sprite;

  constructor(infoSliderDims: Dims) {
    super();
    this.infoSliderDims = infoSliderDims;
    this.addToCon();
    this.addLeftArrow();
    this.addRightArrow();
  }
  handleArrow = (v: number) => this.RootEventBus.emit(EnumRootEventBus.setInfoSliderPageWArr, v);
  setArrowInteractivity(arrow: PIXI.Sprite, interactive: boolean) {
    arrow.interactive = interactive;
    arrow.alpha = interactive ? 1 : .5;
  }

  updateArrowAvaible(eState: "first" | "last" | "middle") {
    if (eState == "first") {
      this.setArrowInteractivity(this.leftArrow, false);
      this.setArrowInteractivity(this.rightArrow, true);
    } else if (eState == "last") {
      this.setArrowInteractivity(this.leftArrow, true);
      this.setArrowInteractivity(this.rightArrow, false);
    } else if (eState == "middle") {
      this.setArrowInteractivity(this.leftArrow, true);
      this.setArrowInteractivity(this.rightArrow, true);
    }
  }
  addLeftArrow() {
    const coord = {
      x: -this.infoSliderDims.width / 2 - 40,
      y: 0
    }
    this.leftArrow = this.generateArrow(coord, false);
  }
  addRightArrow() {
    const coord = {
      x: this.infoSliderDims.width/2 + 40,
      y: 0,
    }
    this.rightArrow = this.generateArrow(coord, true);
  }
  generateArrow(coord: Coord, isRight: boolean) {
    let texture = TextureManager.getTexture(ARROW_PATH);
    const Arrow = new PIXI.Sprite(texture);
    Object.assign(Arrow, coord);
    const scale = .17;
    Arrow.width = 241;
    Arrow.height = 403;
    Arrow.anchor.set(.5)
    Arrow.scale.set(isRight ? scale : -scale, scale);
    Arrow.cursor = "pointer";

    Arrow.interactive = true;
    Arrow.on("mousedown", () => this.handleArrow(isRight ? 1 : -1));
    Arrow.on("touchstart", () => this.handleArrow(isRight ? 1 : -1));
    this.addChild(Arrow);
    return Arrow;
  }

  addToCon() {
    this.InfoSlider.addChild(this);
  }
}